/* Page to contain the 2nd Unit Home page
The 2nd unit crew in in a folder called crewinfo here in the secondUnit folder
The 2nd unit Schedule is in in a folder call schedule2 just below the main schedule folder above
The 2nd unit Callsheet is in in a folder call callsheet2 just below the main callsheet folder above
 */
import React, {useState } from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import styles from "../../styles/Scene.module.css"
import btnStyles from "../../styles/Button.module.css"
import { useRedirect } from "../../hooks/Redirect"
import { Button } from "react-bootstrap"
import TopBox from "../../components/TopBox"
import { useHistory, Link } from "react-router-dom"
import Info from "./Info"
import { useCurrentUser } from "../../contexts/CurrentUserContext"

const SecondHome = () => {
  const currentUser = useCurrentUser()
  useRedirect()
  const history = useHistory()
  const [showInfo, setShowInfo] = useState(false)

  // Television
  const projectCategoryType =
    currentUser?.project_category_type &&
    JSON.parse(currentUser.project_category_type);

  const clickCrew = () => {
    history.push(`/${localStorage.getItem("projectSlug")}/secondcrew/`);};

  return (
    <div>
      <TopBox second="2ND UNIT" />
      {/* add  */}
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} my-1`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <Button
        className={`float-right py-0 mt-1 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => setShowInfo((showInfo) => !showInfo)}
      >
        INFO
      </Button>
      {!showInfo ? "" : <Info />}
      <h3 className="text-center">2nd Unit</h3>
      <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`}/>
      {/* links */}
    <div className={` ${styles.Header}`}>
        <div >
        <Row className={`${styles.ButtonLine} mt-2 mx-3`}>
            {/* crew link */}
            {currentUser &&
            currentUser?.groups.length > 0 &&
            currentUser?.groups[0]?.name !== "Cast" && (
                <Col xs={4} className="text-center">
                <h5
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => clickCrew()}
                >
                    {" "}
                    Crew
                </h5>
                </Col>
            )}
            {/* Schedule link */}
            {currentUser &&
            currentUser?.groups.length > 0 &&
            currentUser?.groups[0]?.name !== "Cast" && (
                <Col xs={4} className="text-center">
                <Link
                to={
                  projectCategoryType !== "Television"
                    ? `/${localStorage.getItem("projectSlug")}/days2unit`
                    : `/${localStorage.getItem(
                        "projectSlug"
                      )}/days2unit/episodes`
                }
              >
                  <h5 className={`py-0 mb-0 ${styles.Button}`}>
                    Schedule
                  </h5>
              </Link>
                </Col>
            )}
            {/* callsheets link */}
            {currentUser &&
            currentUser?.groups.length > 0 &&
            currentUser?.groups[0]?.name !== "Cast" && (
                <Col xs={4} className="text-center">
                <Link
                to={
                  projectCategoryType !== "Television"
                    ? `/${localStorage.getItem("projectSlug")}/callsheets2unit`
                    : `/${localStorage.getItem(
                        "projectSlug"
                      )}/callsheets2unit/episodes`
                }
              >
                <h5 className={`py-0 mb-0 ${styles.Button}`}>
                    Callsheets
                  </h5>
              </Link>
                </Col>
            )}
        </Row>
        </div>
    </div>
    </div>
  )
}

export default SecondHome